import { z } from 'zod';
import { type SexSchema, sexSchema } from '../const/sexSchema';

export const getSubOrSiblingCategoriesSchema = z.custom<[SexSchema, string]>(data => {
    return (
        Array.isArray(data) &&
        data.length === 2 &&
        sexSchema.safeParse(data[0]).success &&
        typeof data[1] === 'string' &&
        data[1].trim().length > 0
    );
});

export type GetSubOrSiblingCategoriesSchema = z.infer<typeof getSubOrSiblingCategoriesSchema>;
